import { render, staticRenderFns } from "./DataInputDict.vue?vue&type=template&id=49d20328&scoped=true&"
import script from "./DataInputDict.vue?vue&type=script&lang=js&"
export * from "./DataInputDict.vue?vue&type=script&lang=js&"
import style0 from "./DataInputDict.vue?vue&type=style&index=0&id=49d20328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d20328",
  null
  
)

export default component.exports